// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__3ZWVn","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__AhF22"};